import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import airconService from "../services/airconunit.service";
import { Airconunitvalidationschema } from "../components/Validation";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, Link } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import authsService from "../services/auths.service";
const Airconunity = (props) => {
  const userinfo = authsService.userinfo();
  const userinfos = authsService.userdata();

  const ref = useRef();
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState("");
  const [eventname, setEventname] = useState("create");

  const [aircons, setAirconunits] = useState([]);
  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [filter, setFilter] = useState("");
  const [filteraircon, setFilteraircon] = useState(props.aircon_id);

  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "aircon ID", value: "" },
    { label: "aircon name", value: "au_name" },
    { label: "Status", value: "au_status" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };
  //form initial value
  const auformik = useFormik({
    initialValues: {
      au_id: "",
      aircon_id: props.aircon_id,
      client_id: props.client_id,
      au_name: "",
      au_type: "",
      au_category: "",
      au_brand: "",
      au_btu: "",
      au_model_no: "",
      au_serial_no: "",
      au_status: "",
      user_name: userinfo.user_name,
    },
    validationSchema: Airconunitvalidationschema,
    enableReinitialize: true,

    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      /* resetForm({ values: "" }); */
    },
  });
  //use effects
  useEffect(() => {
    getallAirconunit();
  }, []);
  useLayoutEffect(() => {
    getallAirconunit();
  }, [page, limit, filter, search, between, sort]);

  //current event
  const airconEvent = (eventname, value) => {
    if (value != "") {
      getAirconunit(value);
      setEventname(eventname);
    }
    setEventname(eventname);
    auformik.resetForm();
  };
  //get allaircon
  const getallAirconunit = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      filteraircon: filteraircon,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconService
      .getallAirconunit(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setAirconunits(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsLoaded(false);
          setAirconunits(null);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort == value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort == value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
      " , " +
      format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  //between
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get aircon
  const getAirconunit = (value) => {
    setIsLoaded(true);
    airconService
      .getAirconunit(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          auformik.setValues({
            au_id: data.au_id,
            aircon_id: data.aircon_id,
            client_id: data.client_id,
            au_name: data.au_name,
            au_type: data.au_type,
            au_category: data.au_category,
            au_brand: data.au_brand,
            au_btu: data.au_btu,
            au_model_no: data.au_model_no,
            au_serial_no: data.au_serial_no,
            au_status: data.au_status,
            user_name: userinfo.user_name,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //create aircon
  const createAirconunit = () => {
    console.log(auformik.values);
    airconService
      .createAirconunit(auformik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create");
          getallAirconunit();
          auformik.resetForm();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //update aircon
  const updateAirconunit = (value) => {
    console.log(JSON.stringify(auformik.values, null, 2));
    airconService
      .updateAirconunit(auformik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("view");
          getallAirconunit();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //delete aircon
  const deleteAirconunit = (value) => {
    console.log(value);
    airconService
      .deleteAirconunit(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create", "");
          auformik.resetForm();
          getallAirconunit();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call aircon clicks to request another page.
  if (ismessage === "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  return (
    <div className="">
      <div className="">
        {/*  loader and error handler */}
        {<Toastmessage ref={ref} />}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="aircon-container">
        {/*  modal form */}
        <div
          className="modal"
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {/* <div className="modal-header">
                <h5 className="modal-title" id="staticBackdropLabel">
                  Modal title
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div> */}
              <div className="modal-body">
                {/* aircon form */}
                <div className="card border-0 mb-2">
                  <div className="card-body ">
                    <div className="d-flex">
                      <h5 className="card-title p-0 m-0 me-auto">Aircon Unit</h5>
                      {eventname == "create" ? (
                        <></>
                      ) : (
                        <div className="">
                          <div className="dropdown ">
                            <a
                              className="btn btn-sm"
                              role="button"
                              id="airconeventdropdownMenuLink"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              Option
                              {/*  <i
                                className="fa fa-ellipsis-v"
                                aria-hidden="true"
                              ></i> */}
                            </a>
                            <ul
                              className="dropdown-menu"
                              aria-labelledby="airconeventdropdownMenuLink"
                            >
                              <li>
                                <a
                                  onClick={() => {
                                    airconEvent("edit", auformik.values.au_id);
                                  }}
                                  className="dropdown-item"
                                >
                                  Edit
                                </a>
                              </li>
                              <li>
                                <a
                                  onClick={() =>
                                    airconEvent("delete", auformik.values.au_id)
                                  }
                                  className="dropdown-item"
                                >
                                  Delete
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                      <div>
                        <button
                          className="btn btn-sm text-danger"
                          data-bs-dismiss="modal"
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <form onSubmit={auformik.handleSubmit}>
                      <div className="row">
                        <div className="col-md-12 d-none">
                          <label htmlFor="au_id" className="form-label">
                            Unit ID
                          </label>
                          <div className="input-group col-md-6">
                            <input
                              className="form-control"
                              placeholder="Enter Airconunit ID"
                              id="au_id"
                              type="text"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              {...auformik.getFieldProps("au_id")}
                            />
                          </div>
                          <div>
                            {auformik.touched.au_id && auformik.errors.au_id ? (
                              <div className="error">
                                {auformik.errors.au_id}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_type" className="form-label">
                            Type
                          </label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              placeholder="Enter Type"
                              id="au_type"
                              type="text"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              {...auformik.getFieldProps("au_type")}
                            />
                          </div>
                          <div>
                            {auformik.touched.au_type &&
                              auformik.errors.au_type ? (
                              <div className="error">
                                {auformik.errors.au_type}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_category" className="form-label">
                            Category
                          </label>
                          <div className="input-group col-md-6">
                            <select
                              id="au_category"
                              {...auformik.getFieldProps("au_category")}
                              className="form-select"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              aria-label="au_category"
                            >
                              <option value="" disabled>
                                Select status
                              </option>
                              <option value="indoor unit">Indoor Unit</option>
                              <option value="outdoor unit">Outdoor Unit</option>
                            </select>
                          </div>
                          <div>
                            {auformik.touched.au_category &&
                              auformik.errors.au_category ? (
                              <div className="error">
                                {auformik.errors.au_category}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_brand" className="form-label">
                            Brand
                          </label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              placeholder="Enter Brand"
                              id="au_brand"
                              type="text"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              {...auformik.getFieldProps("au_brand")}
                            />
                          </div>
                          <div>
                            {auformik.touched.au_brand &&
                              auformik.errors.au_brand ? (
                              <div className="error">
                                {auformik.errors.au_brand}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_btu" className="form-label">
                            BTU
                          </label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              placeholder="Enter BTU"
                              id="au_btu"
                              type="text"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              {...auformik.getFieldProps("au_btu")}
                            />
                          </div>
                          <div>
                            {auformik.touched.au_btu &&
                              auformik.errors.au_btu ? (
                              <div className="error">
                                {auformik.errors.au_btu}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_model_no" className="form-label">
                            Model number
                          </label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              placeholder="Enter Model number"
                              id="au_model_no"
                              type="text"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              {...auformik.getFieldProps("au_model_no")}
                            />
                          </div>
                          <div>
                            {auformik.touched.au_model_no &&
                              auformik.errors.au_model_no ? (
                              <div className="error">
                                {auformik.errors.au_model_no}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_serial_no" className="form-label">
                            Serial number
                          </label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              placeholder="Enter Serial number"
                              id="au_serial_no"
                              type="text"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                              {...auformik.getFieldProps("au_serial_no")}
                            />
                          </div>
                          <div>
                            {auformik.touched.au_serial_no &&
                              auformik.errors.au_serial_no ? (
                              <div className="error">
                                {auformik.errors.au_serial_no}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label htmlFor="au_status" className="form-label">
                            status
                          </label>
                          <div className="input-group col-md-6">
                            <select
                              id="au_status"
                              {...auformik.getFieldProps("au_status")}
                              className="form-select"
                              aria-label="au_status"
                              disabled={
                                eventname == "view"
                                  ? true
                                  : eventname == "delete"
                                    ? true
                                    : false
                              }
                            >
                              <option value="" disabled>
                                Select status
                              </option>
                              <option value="pending">Pending</option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                            </select>
                          </div>
                          <div>
                            {auformik.touched.au_status &&
                              auformik.errors.au_status ? (
                              <div className="error">
                                {auformik.errors.au_status}
                              </div>
                            ) : null}
                          </div>
                        </div>
                        {/* aircon event buttons */}
                        <div className="col-md-12 pt-2 pb-2">
                          {eventname === "create" ? (
                            <>
                              <button
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                disabled={!auformik.isValid || !auformik.dirty}
                                onClick={() => createAirconunit()}
                                className="btn btn-primary me-2"
                              >
                                Create
                              </button>
                              <button
                                disabled={!auformik.dirty}
                                onClick={auformik.handleReset}
                                className="btn btn-secondary"
                              >
                                Clear
                              </button>
                            </>
                          ) : eventname === "edit" ? (
                            <>
                              <button
                                onClick={() => updateAirconunit()}
                                className="btn btn-primary me-2"
                              >
                                Update
                              </button>
                              <a
                                onClick={() => {
                                  airconEvent("view", auformik.values.au_id);
                                }}
                                className="btn btn-secondary"
                              >
                                Cancel
                              </a>
                            </>
                          ) : eventname === "delete" ? (
                            <>
                              <button
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() =>
                                  deleteAirconunit(auformik.values.au_id)
                                }
                                className="btn btn-danger me-2 "
                              >
                                Delete
                              </button>
                              <a
                                onClick={() => {
                                  airconEvent("view", auformik.values.au_id);
                                }}
                                className="btn btn-secondary"
                              >
                                Cancel
                              </a>
                            </>
                          ) : (
                            <>
                              {/* <button
                                onClick={() => {
                                  airconEvent("create", "");
                                  auformik.handleReset();
                                }}
                                className="btn btn-primary"
                              >
                                Close
                              </button> */}
                            </>
                          )}
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer d-none">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" className="btn btn-primary">
                  Understood
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* tebale header part search,filter,sort */}
        <div className="d-flex  mb-2 ">
          {/* filter status*/}
          <div className={userinfos.login_type != "client" ? "dropdown m-1" : "d-none"} >
            <button
              className="btn btn-primary "
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Airconunit Status</li>
              {filterarray.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.status_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.status_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* create aircon */}
          <div className={userinfos.login_type != "client" ? "ms-auto m-1" : "d-none"} >
            {userinfos.login_type &&
              <button
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
                onClick={() => {
                  setEventname("create", "");
                  auformik.handleReset();
                }}
                type="submit"
                className="btn btn-primary  w-100"
              >
                <i className="fa fa-plus-circle"></i>
              </button>}


          </div>

          {/* search */}
          <div className="d-none m-1">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1 ms-auto d-none">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
        </div>
        {/* table section*/}
        <div>
          {aircons ? (
            <>
              {aircons.map((data, index) => (
                <div className="card shadow-sm border-0 mb-2" key={index}>
                  <div className="card-body">
                    <div className="card-title mb-0 pb-0 d-flex flex-wrap fw-bolder">
                      <div className="flex-fill">
                        {data.au_type}-{data.au_brand}-{data.au_btu}
                      </div>

                      <div className={userinfos.login_type === "client" ? "d-none" : ""} onClick={() => airconEvent("view", data.au_id)}>
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#staticBackdrop"
                          className={selectedcolor(data.au_status)}
                        >
                          {data.au_status}
                        </span>
                      </div>
                    </div>
                    <div style={{ fontSize: 12 }}>
                      <span
                        className=" text-secondary  text-capitalize"
                        style={{}}
                      >
                        ID:{data.au_id}/created:{data.createdBy}/date:
                        {data.createdAt}
                      </span>
                    </div>
                    <div className="textwrapmulti">
                      <div> ModelNo: {data.au_model_no}</div>
                      <div>Serial no:{data.au_serial_no}</div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <><div className="text-center p-3 border rounded"> data found</div></>
          )}
        </div>
      </div>
    </div>
  );
};

export default Airconunity;
